import "./LanguageSelector.css"
import {IconCaretDownFilled} from "@tabler/icons-react";
import {createRef, useState} from "react";
import {useTranslation} from "react-i18next";
import useOutsideHandler from "../../util/OutsideHandler";

const LANGUAGES = ["cs", "en"];

export default function LanguageSelector() {
    const {i18n} = useTranslation();
    const language = LANGUAGES.includes(i18n.language) ? i18n.language : "cs";

    const [expanded, setExpanded] = useState(false);
    const ref = createRef<HTMLDivElement>()

    useOutsideHandler(ref, () => setExpanded(false));

    return <div onClick={() => {
        setExpanded(!expanded);
    }} ref={ref} className={`language-selector${expanded ? " expanded" : ""}`}>
        {language.toUpperCase()}
        <IconCaretDownFilled/>
        <div className={"other"}>
            {
                LANGUAGES.filter(lang => lang !== language).map(lang =>
                    <p className={"language"} key={lang}
                       onClick={() => i18n.changeLanguage(lang)}>{lang.toUpperCase()}</p>)
            }
        </div>
    </div>
}
